const surfing = {
	name: 'Memo',
	// icon: 'Surfing',
	color: 'info',
};
const kiteSurfing = {
	name: 'Client visit',
	// icon: 'Kitesurfing',
	color: 'danger',
};
const tennis = {
	name: 'Supplier visit',
	// icon: 'SportsTennis',
	color: 'success',
};
const kayaking = {
	name: 'Staff Interview',
	// icon: 'Kayaking',
	color: 'info',
};
const handball = {
	name: 'Meeting',
	// icon: 'SportsHandball',
	color: 'warning',
};
const iceSkating = {
	name: 'Ad hoc event',
	// icon: 'IceSkating',
	color: 'info',
};
const snowboarding = {
	name: 'Bank holiday',
	// icon: 'Snowboarding',
	color: 'warning',
};
// const volleyball = {
// 	name: 'Volleyball',
// 	icon: 'SportsVolleyball',
// 	color: 'warning',
// };
// const cricket = {
// 	name: 'Cricket',
// 	icon: 'SportsCricket',
// 	color: 'success',
// };
// const yoga = {
// 	name: 'Yoga',
// 	icon: 'SelfImprovement',
// 	color: 'success',
// };
// const hiking = {
// 	name: 'Hiking',
// 	icon: 'Hiking',
// 	color: 'danger',
// };
// const football = {
// 	name: 'Football',
// 	icon: 'SportsFootball',
// 	color: 'success',
// };

const SERVICES = {
	SURFING: surfing,
	KITE_SURFING: kiteSurfing,
	TENNIS: tennis,
	KAYAKING: kayaking,
	HANDBALL: handball,
	ICE_SKATING: iceSkating,
	SNOWBOARDING: snowboarding,
	// VOLLEYBALL: volleyball,
	// CRICKET: cricket,
	// YOGA: yoga,
	// HIKING: hiking,
	// FOOTBALL: football,
};

export function getServiceDataWithServiceName(serviceName) {
	return SERVICES[
		Object.keys(SERVICES).filter((f) => SERVICES[f].name.toString() === serviceName)
	];
}

export default SERVICES;
